import React from 'react';
import { useIntl } from 'react-intl';
import { EmptyComponent, Evidence } from '@eas/common-web';
import { useDatedEvidence } from '@composite/evidence/dated-evidence';
import { EvidenceApiUrl } from '@enums';
import { EsFileReturnLog } from '@models';
import { useColumns } from './es-file-return-log-columns';
import { Fields } from './es-file-return-log-fields';

export function EsFileReturnLogs() {
  const intl = useIntl();

  const evidence = useDatedEvidence<EsFileReturnLog>({
    identifier: 'ES_FILE_RETURN_LOG',
    apiProps: {
      url: EvidenceApiUrl.ES_FILE_RETURN_LOGS,
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'ES__ES_FILE_RETURN_LOG__TABLE__TITLE',
        defaultMessage: 'Předání do spisovny',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      showNamedSettingsButton: false,
      defaultSorts: [{ field: 'created', datakey: 'created', type: 'FIELD', order: 'DESC' }],
    },
    detailProps: {
      FieldsComponent: Fields,
      GeneralFieldsComponent: EmptyComponent,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__ES_FILE_RETURN_LOG__DETAIL__TITLE',
          defaultMessage: 'Předání do spisovny',
        }),
        showBtn: (btn) => ['REFRESH', 'SHARE'].includes(btn),
      },
    },
  });

  return <Evidence {...evidence} />;
}
